<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <p class="label">时间段：</p>
              <el-date-picker
                style="margin: 0 10px"
                size="small"
                class="date-input"
                v-model="timeRange"
                type="datetimerange"
                align="right"
                unlink-panels
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </div>
            <div class="btn-box">
              <button class="search" @click="handleSearch">筛选</button>
              <button class="reset" @click="handleReset">重置</button>
            </div>
          </div>
        </div>
        <!-- 表格 -->
        <el-table
          :data="businessList"
          class="table no-border-table"
          ref="table"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="name"
            align="center"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            prop="sales"
            align="center"
            label="商品销量"
          ></el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- <el-dialog :visible.sync="addShow" class="dialog" width="560px" top="25vh">
        <div slot="title" class="dialog-title">
          {{ (type === "add" ? "添加" : "编辑") + "商家" }}
        </div>
        <el-form
          ref="form"
          :rules="rules"
          :model="addForm"
          class="form"
          label-width="auto"
        >
          <el-form-item label="商家名称：" prop="sort" class="form-item">
            <el-input
              placeholder="请输入商家名称"
              class="add-renovation-input"
              style="width: 160px"
              v-model="addForm.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="sort" class="form-item">
            <el-input
              placeholder="请输入联系电话"
              class="add-renovation-input"
              style="width: 160px"
              v-model="addForm.phone"
              type="number"
              onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="cancel-btn btn" @click="addShow = false"
            >取 消</el-button
          >
          <el-button class="confirm-btn btn" @click="handleConfirm"
            >确 定</el-button
          >
        </div>
      </el-dialog> -->
    <!-- 修改排序弹窗 -->
    <!-- <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
        <el-form label-width="60px" size="mini" ref="editSort" inline-message>
          <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
            <el-input v-model="currentSort" type="number" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn cancel-btn" @click="sortShow = false"
            >取 消</el-button
          >
          <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
        </div>
      </el-dialog> -->
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '商品销量'
      },
      businessList: [], // 轮播列表
      rules: {},
      sortShow: false,
      currentSort: 0,
      addForm: {
        name: '',
        phone: null
      },
      addShow: false,
      businessId: null,
      type: '',
      filter: {},
      timeRange: []
    };
  },
  mounted() {
    // 获取列表
    this.getList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    // 获取列表
    getList() {
      this.loading++;
      this.timeRange = this.timeRange || [];
      this.filter.begin = this.timeRange[0] || '';
      this.filter.end = this.timeRange[1] || '';
      this.httpGet(this.$root.getOrderSalesList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.businessList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    handleSearch(){
      this.currentPage = 1;
      this.getList();
    },
    handleReset(){
      this.timeRange = [];
      this.currentPage = 1;
      this.getList();
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      // 表格按钮
      .table-btn {
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 6px;
        min-width: 80px;
        width: auto;
        box-sizing: border-box;
      }

      .table-img {
        height: 36px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .addImg {
    .icon {
      width: 80px;
      height: 80px;
    }
  }

  .form {
    margin-top: 16px;
    margin-bottom: 20px;
    // padding-left: 60px;
    flex-y(flex-start, center);

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }
}
</style>
